import axios from "axios";
import TokenService from "./token";

const { REACT_APP_ENDPOINT } = process.env;
const ENDPOINT = `${REACT_APP_ENDPOINT}/api/Client/`;

export default class clientesService {
  static async contact(formData) {
    const respuesta = await axios
      .post(`${ENDPOINT}contactForm`, formData)
      .then((response) => {
        return response;
      });
    return respuesta.data;
  }

  static async fetch() {
    const respuesta = await axios.get(`${ENDPOINT}all`).then((response) => {
      return response;
    });
    return respuesta.data.data.$values;
  }

  // Recordar cambio en el fetch
  static async fetchAll() {
    const respuesta = await axios.get(`${ENDPOINT}all`).then((response) => {
      return response;
    });
    return respuesta.data.data.$values;
  }

  static async fetchById(id) {
    const respuesta = await axios.get(`${ENDPOINT}${id}`).then((response) => {
      return response;
    });
    return respuesta.data.data;
  }

  static async find(id, contactoId) {
    debugger;
    const respuesta = await axios
      .get(`${ENDPOINT}${id}/${contactoId}`)
      .then((response) => {
        return response;
      });
    return respuesta.data.data;
  }

  static async getClienteByNroDoc(nroDoc) {
    const respuesta = await axios
      .get(`${ENDPOINT}GetClienteByNroDoc?nroDoc=${nroDoc}`)
      .then((response) => {
        return response;
      });
    return respuesta.data.data;
  }

  static async search(search) {
    const respuesta = await axios
      .post(`${ENDPOINT}search`, search)
      .then((response) => {
        return response;
      });
    return respuesta.data.data.$values;
  }

  static async updateAddress(updateAddressRequest) {
    const respuesta = await axios
      .post(`${ENDPOINT}updateAddress`, updateAddressRequest)
      .then((response) => {
        return response;
      });
    return respuesta.data.data;
  }

  static async enviarEmailRegistracion(registrarClienteRequest) {
    try {
      const respuesta = await axios.post(
        `${ENDPOINT}registerClient`,
        registrarClienteRequest,
        {
          // headers: {
          //     authorization: TokenService.getAuthHeader(),
          // },
          // withCredentials: true
        },
      );
      return respuesta.data.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        TokenService.cerrarSession();
      }
      throw error; // Re-lanza el error si no es 401
    }
  }
}
